<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    width="1100px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :amzSpuCode="amzSpuCode"
      :type="type"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="$refs.main.approved()"
        v-if="type === 'approved'"
      >
        {{ '通过' }}
      </el-button>
      <el-button
        type="danger"
        size="small"
        @click="$refs.main.reject()"
        v-if="type === 'reject'"
      >
        {{ '驳回' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    amzSpuCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        detail: this.$l('title_label_detail') || '详情',
        approved: this.$l('title_label_approved') || '通过转正',
        reject: this.$l('title_label_reject') || '驳回转正',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
